import ga4 from "utils/trackings/ga4"
import analytics from "@mobi/libraries/analytics"
import isClient from "@mobi/utils/browser/isClient"

const track = {
  pageView: () => {
    if (!isClient()) return

    const pageViewPayload = {
      analytics: {
        event_name: "screen_view",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
        },
      },
    }

    const entrancePayload = {
      analytics: {
        event_name: "entrance",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
        },
      },
    }

    ga4.track(pageViewPayload, { setUserProperties: true })
    ga4.track(entrancePayload)
    analytics.track("LPPageView")
    analytics.track("pageView", { pageName: "LandingPage" })
  },
  formButtonClick: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "click",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
          detail: "landing-page-consultar-cpf-hero",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentButtonClick", { name: "LandingPage:BotaoForm" })
  },
  cardsClick: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "click",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
          detail: "landing-page-renegocie-produtos",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentButtonClick", { name: "LandingPage:CardProdutos" })
  },
  floatButtonClick: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "click",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
          detail: "landing-page-consultar-cpf-flutuante",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentButtonClick", {
      name: "LandingPage:BotaoFlutuante",
    })
  },
  accessBankslipClick: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "click",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
          detail: "landing-page-acessar-boleto",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentButtonClick", { name: "LandingPage:AcessarBoleto" })
  },
  faqClick: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "click",
        parameters: {
          custom_path: "/landing-page",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
          detail: "landing-page-faq",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentButtonClick", { name: "LandingPage:Faq" })
  },

  documentValidation: () => {
    if (!isClient()) return

    const payload = {
      analytics: {
        event_name: "screen_view",
        parameters: {
          custom_path: "/dados-pessoais",
          implementation_team:
            "growth-recuperacao:conquista-digital-de-clientes",
        },
      },
    }

    ga4.track(payload)
    analytics.track("segmentPageView", "landingPage:DocumentoValidado")
  },
}

export default track
